// extracted by mini-css-extract-plugin
module.exports = {"chipContainer":"Chip-module--chipContainer--3yhFA","chip":"Chip-module--chip--17TOs","clickable":"Chip-module--clickable--2xcR-","active":"Chip-module--active--33UdS"};